"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayerContentHTML = exports.MARKER_XHR = void 0;
exports.MARKER_XHR = 'headless';
const LayerContentHTML = () => {
    return null;
};
exports.LayerContentHTML = LayerContentHTML;
//# sourceMappingURL=LayerContentHTML.js.map